<template>
    <GlobalFooter class="i-copyright" :links="links" :copyright="copyright" />
</template>
<script>
	import Setting from '@/setting';
    export default {
        name: 'i-copyright',
        data () {
            return {
                links: [
                    // {
                    //     title: '官网',
                    //     key: '官网',
                    //     href: 'http://www.agilebpm.cn/',
                    //     blankTarget: true
                    // },
                    // {
                    //     title: '文档',
                    //     key: '文档',
                    //     href: 'http://www.agilebpm.cn/zh-cn/docs/',
                    //     blankTarget: true
                    // },
                    // {
                    //     title: 'GVP',
                    //     key: 'Gitee',
                    //     href: 'https://gitee.com/agile-bpm',
                    //     blankTarget: true
                    // }
                ],
                copyright:  JSON.parse(localStorage.getItem('systemConfigInfos')).copyright
            }
        }
    }
</script>
<style lang="less">
    .i-copyright{
        flex: 0 0 auto;
         &-hidden{
            display: none;
        }
    }
    .ivu-global-footer {
	    margin: -10px 0 10px 0 !important;
	    padding: 0 16px;
	    text-align: center;
	}
</style>
